import React from "react";
import { Box } from '@mui/joy';
import { Pie } from 'src/mtska-frontend-app-component';

const PieFleet = ({ user, filters, createSliceFilterHandler, handleFilterChange, t }) => {
    return (
        <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
            {!user?.data?.roles?.includes('Area manager') &&
                <Box className="dashboard-menu-item">
                    <Pie
                        title={t("Distribuzione per Rete Commerciale")}
                        dataProviderName={"statisticsviews/fleetbyarea/aggregated/views_cars_car/_related_account_area_name"}
                        filters={{
                            items: [
                                ...(filters?.items || [])
                            ]
                        }}
                        handleFilterChange={createSliceFilterHandler('_related_account_area_name', handleFilterChange)}
                        donutWidth={300}
                    />
                </Box>
            }
            {!user?.data?.roles?.includes('Area manager') &&
                <Box className="dashboard-menu-item">
                    <Pie
                        title={t("Distribuzione per Area Commerciale")}
                        dataProviderName={"statisticsviews/fleetbyaccount/aggregated/views_cars_car/_related_account_shop_name"}
                        filters={{
                            items: [
                                ...(filters?.items || [])
                            ]
                        }}
                        handleFilterChange={createSliceFilterHandler('_related_account_shop_name', handleFilterChange)}
                        donutWidth={300}
                    />
                </Box>
            }
            <Box className="dashboard-menu-item">
                <Pie
                    title={"Distribuzione per Profilazione Cliente"}
                    dataProviderName={"statisticsviews/fleetbycustomer/aggregated/views_cars_car/_related_legalEntity_commercialCluster"}
                    filters={{
                        items: [
                            ...(filters?.items || [])
                        ]
                    }}
                    handleFilterChange={createSliceFilterHandler('_related_legalEntity_commercialCluster', handleFilterChange)}
                    donutWidth={300}
                />
            </Box>
            <Box className="dashboard-menu-item">
                <Pie
                    title={"Distribuzione per Noleggiatore"}
                    dataProviderName={"statisticsviews/fleetbyrenter/aggregated/views_cars_car/_related_renter_name"}
                    filters={{
                        items: [
                            ...(filters?.items || [])
                        ]
                    }}
                    handleFilterChange={createSliceFilterHandler('_related_renter_name', handleFilterChange)}
                    donutWidth={300}
                />
            </Box>
        </Box>
    )
}

export default PieFleet